// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

export function isIE(){
    return /*@cc_on!@*/false || !!document.documentMode;
}

export function isEdge(){
    return !isIE() && !!window.StyleMedia;
    // window.navigator.userAgent.indexOf("Edge")
}

export function isMS(){
    return ((/*@cc_on!@*/false || !!document.documentMode) || ((/*@cc_on!@*/false || !!document.documentMode) && !!window.StyleMedia))
}


// WEBPACK FOOTER //
// ./src/helpers/Browser.js